const Img = (props) => {
  let {src} = props;

  src = src.replace('test.img.sumeme.com', 'test-img.sumeme.com')

  return <img {...props} src={src}/>
}

export default Img;
